import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { MEDICATIONS, MED_DESCRIPTION, MED_DOSE, MED_PRESCRIPTION, MED_START_DATE, MED_STOP_DATE } from '../constants';

const MedHeaders = () => {
  const medHeaderStyles = [styles.FacesheetText, styles.pYPointOneCm, styles.fontWeightBold];
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.row, styles.width100, styles.justifyContentAround]
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.width20]
  }, /*#__PURE__*/React.createElement(Text, {
    style: medHeaderStyles
  }, defaults.medicationsTitle)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width33]
  }, /*#__PURE__*/React.createElement(Text, {
    style: medHeaderStyles
  }, defaults.instructions)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width5]
  }, /*#__PURE__*/React.createElement(Text, {
    style: medHeaderStyles
  }, defaults.dose)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width20]
  }, /*#__PURE__*/React.createElement(Text, {
    style: medHeaderStyles
  }, defaults.orderedBy)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width10]
  }, /*#__PURE__*/React.createElement(Text, {
    style: medHeaderStyles
  }, defaults.start)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width10]
  }, /*#__PURE__*/React.createElement(Text, {
    style: medHeaderStyles
  }, defaults.stop)));
};

var _ref = /*#__PURE__*/React.createElement(MedHeaders, null);

export const Medications = ({
  meds
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, defaults.medicationsTitle), _ref, Array.isArray(meds) ? meds.map(med => /*#__PURE__*/React.createElement(Medication, {
  med: med
})) : /*#__PURE__*/React.createElement(Medication, {
  med: meds
}));

const Medication = ({
  med
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.row, styles.width100, styles.justifyContentAround],
  key: `${med[MED_DESCRIPTION]}-${med[MED_START_DATE]}`
}, /*#__PURE__*/React.createElement(View, {
  style: [styles.width20]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, med[MED_DESCRIPTION])), /*#__PURE__*/React.createElement(View, {
  style: [styles.width33]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, med[MEDICATIONS])), /*#__PURE__*/React.createElement(View, {
  style: [styles.width5]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, med[MED_DOSE])), /*#__PURE__*/React.createElement(View, {
  style: [styles.width20]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, med[MED_PRESCRIPTION])), /*#__PURE__*/React.createElement(View, {
  style: [styles.width10]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, med[MED_START_DATE])), /*#__PURE__*/React.createElement(View, {
  style: [styles.width10]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, med[MED_STOP_DATE] || 'Present')));